/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { Component } from '@wordpress/element';
import {
	InnerBlocks,
} from '@wordpress/block-editor';

/**
 * Inner dependencies.
 */
import Inspector from './inspector';
import { generateCustomStyleCode } from '../../extensions/custom-styles';

class edit extends Component {
	componentDidMount() {
		const { attributes, setAttributes, clientId } = this.props;
		const { blockAdvanceOptions, isSaved } = attributes;
		let saveIt = false;
		if ( ! isSaved ) {
			setAttributes( { isSaved: true, blockClientId: clientId } );
			saveIt = true;
		}
		generateCustomStyleCode( blockAdvanceOptions, { ...this.props }, saveIt );
	}

	render() {
		const { attributes, className, clientId, isSelected } = this.props;
		const { align } = attributes;

		const wrapperClasses = classnames(
			className,
			`align${ align }`,
			`gutenify-block-container-wrapper`,
		);
		return <div className={ wrapperClasses }>
			{ isSelected && <Inspector { ...this.props } /> }

			<div id={ `gutenify-section-${ clientId }` }>
				<div className="gutenify-container-background"></div>
				<div className="gutenify-container">
					<InnerBlocks
						// __experimentalCaptureToolbars={ true }
						renderAppender={ () => (
							<InnerBlocks.ButtonBlockAppender />
						) }
					/>
				</div>
			</div>
		</div>;
	}
}

export default edit;
